import axios from "axios";
import { buildApiUrl } from "../config/api";

export async function fetchTeacherCurrentTermSubjects(teacherId) {
    const { data } = await axios.get(buildApiUrl(`/TermSubject/teacher/${teacherId}/current`));
    return data;
}

export async function fetchClassTermSubjects(classId) {
    const { data } = await axios.get(buildApiUrl(`/TermSubject/class/${classId}`));
    return data;
}

export async function assignTermSubject(payload) {
    const { data } = await axios.post(buildApiUrl("/TermSubject/assign"), payload);
    return data;
}

export async function unassignTermSubject(payload) {
    const { data } = await axios.post(buildApiUrl("/TermSubject/unassign"), payload);
    return data;
}

export async function createSubjectChangeRequest(payload) {
    const { data } = await axios.post(buildApiUrl("/TermSubject/change-request"), payload);
    return data;
}

export async function fetchSchoolSubjectChangeRequests(schoolId, status) {
    const qs = status ? `?status=${encodeURIComponent(status)}` : "";
    const { data } = await axios.get(buildApiUrl(`/TermSubject/change-requests/school/${schoolId}${qs}`));
    return data;
}

export async function fetchFormTeacherChangeRequests(teacherId) {
    const { data } = await axios.get(buildApiUrl(`/TermSubject/change-requests/form-teacher/${teacherId}`));
    return data;
}

export async function reviewFormTeacherChangeRequest(id, payload) {
    const { data } = await axios.put(buildApiUrl(`/TermSubject/change-request/${id}/form-teacher`), payload);
    return data;
}

export async function reviewAdminChangeRequest(id, payload) {
    const { data } = await axios.put(buildApiUrl(`/TermSubject/change-request/${id}/admin`), payload);
    return data;
}

export async function setClassElectiveWindow(classId, { open, teacherId }) {
    const { data } = await axios.put(buildApiUrl(`/TermSubject/elective-window/${classId}`), { open, teacherId });
    return data;
}
